import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { get_all_beneficiaries } from '../api/beneficiary_api';
import GenericList from '../components/GenericList';
import '../styles/Beneficiaries.css';
import GenericSearch from './GenericSearch';
import { useInfiniteScroll } from '../hooks/useInfiniteScroll';
import { exportAllStudentsToExcel } from '../utils/exportToExcel';


const Beneficiaries = () => {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const searchTerm = searchParams.get('search') || '';
    const searchKeyType = searchParams.get('searchKey') || 'first_name';
    const checkDate = searchParams.get('checkDate') || '';
    const welfareFormFilter = searchParams.get('welfareFormFilter') || '';
    const setSearchTerm = (val) => setSearchParams(prev => {
        const p = new URLSearchParams(prev);
        p.set('search', val);
        if (val !== 'סיוע ורווחה') p.delete('welfareFormFilter');
        return p;
    }, { replace: true });
    const setSearchKeyType = (val) => setSearchParams(prev => {
        const p = new URLSearchParams(prev);
        const currentKey = p.get('searchKey') || 'first_name';
        p.set('searchKey', val);
        if (currentKey !== val && (currentKey === 'category' || val === 'category')) {
            p.delete('search');
            p.delete('welfareFormFilter');
        } else if (val !== 'category') {
            p.delete('welfareFormFilter');
        }
        return p;
    }, { replace: true });
    const setWelfareFormFilter = (val) => setSearchParams(prev => {
        const p = new URLSearchParams(prev);
        if (val) p.set('welfareFormFilter', val);
        else p.delete('welfareFormFilter');
        return p;
    }, { replace: true });
    const setCheckDate = (val) => setSearchParams(prev => {
        const p = new URLSearchParams(prev);
        if (val) p.set('checkDate', val);
        else p.delete('checkDate');
        return p;
    }, { replace: true });
    const handleAddBeneficiaryClick = () => navigate('/add_beneficiary');
    const handleRowClick = (item) => navigate(`/beneficiaries/${item.id}`);
    const { items, loadMore, loading, hasMore } = useInfiniteScroll(
        get_all_beneficiaries,
        searchTerm,
        searchKeyType,
        searchKeyType === 'payment_method' && searchTerm === 'שיק' ? checkDate : '',
        searchKeyType === 'category' && searchTerm === 'סיוע ורווחה' ? welfareFormFilter : ''
    );
    const [selectedBeneficiaryIds, setSelectedBeneficiaryIds] = useState([]);

    const handleExportClick = async () => {
        try {
            await exportAllStudentsToExcel(selectedBeneficiaryIds, {
                providerName: searchKeyType === 'provider_name' ? searchTerm : '',
                paymentMethod: searchKeyType === 'payment_method' ? searchTerm : '',
                checkDate: searchKeyType === 'payment_method' && searchTerm === 'שיק' ? checkDate : '',
                category: searchKeyType === 'category' ? searchTerm : '',
                welfareFormFilter: searchKeyType === 'category' && searchTerm === 'סיוע ורווחה'
                    && ['has_form', 'no_form'].includes(welfareFormFilter) ? welfareFormFilter : ''
            });
        } catch (error) {
            console.error('Export failed:', error);
            alert(`שגיאה בייצוא: ${error.message}`);
        }
    };

    const columns = [
        { key: 'id', label: 'ת.ז/דרכון' },
        {
            key: 'first_name',
            label: 'שם פרטי',
            render: (item) => (
                <span style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    {item.first_name || '-'}
                    {item.has_documents > 0 && (
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#EF5DA8"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            title="יש מסמכים מצורפים"
                            style={{ flexShrink: 0 }}
                        >
                            <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
                        </svg>
                    )}
                </span>
            )
        },
        { key: 'last_name', label: 'שם משפחה' },
        { key: 'address', label: 'כתובת' },
        { key: 'referring_teacher', label: 'מורה מקשרת' },
        { key: 'type_case', label: 'דירוג מקרה' },
        { key: 'phone', label: 'פלאפון' },
        { key: 'email', label: 'אימייל' },
        { key: 'transaction_count', label: 'מספר פעולות' }
    ];

    return (
        <>
            {/* <NavBar setBeneficiaries={setBeneficiaries} /> */}
            <div className="top-buttons-container" style={{ marginBottom: "1.25rem" }}>
                {/* כפתור חזרה דף אחורה - עם חץ */}
                <button className="round-nav-btn" onClick={() => navigate(-1)} title="חזרה">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#EF5DA8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                        <polyline points="12 5 19 12 12 19"></polyline>
                    </svg>
                </button>
                {/* כפתור דף הבית - עם בית */}
                <button className="round-nav-btn" onClick={() => navigate('/main_screen')} title="דף הבית">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#EF5DA8" strokeWidth="2">
                        <path d="M12 3L2 12h3v7h4v-5h6v5h4v-7h3L12 3z" />
                    </svg>
                </button>
            </div>
            <div className="beneficiaries-container" style={{ marginTop: "4rem" }}>
                <div className="header">
                    <h2 className="title">ניהול נתמכים</h2>
                    <GenericSearch
                        searchTerm={searchTerm}
                        setSearchTerm={setSearchTerm}
                        checkDate={checkDate}
                        setCheckDate={setCheckDate}
                        searchKeyType={searchKeyType}
                        setSearchKeyType={setSearchKeyType}
                        searchFields={[
                            { key: 'id', label: 'ת.ז/דרכון' },
                            { key: 'first_name', label: 'שם פרטי' },
                            { key: 'last_name', label: 'שם משפחה' },
                            { key: 'address', label: 'כתובת' },
                            { key: 'referring_teacher', label: 'מורה מקשרת' },
                            { key: 'provider_name', label: 'שם ספק' },
                            {
                                key: 'payment_method',
                                label: 'אופן תשלום',
                                options: [
                                    'שובר קנייה',
                                    'שוברי קניה',
                                    'העברה בנקאית ישירה',
                                    'העברה בנקאית',
                                    'העברה בנקאית לספק',
                                    'תשלום לספק',
                                    'העברה לספק',
                                    'שיק',
                                    'תמיכה שוות כסף',
                                    'מזומן',
                                    'כרטיס אשראי'
                                ]
                            },
                            {
                                key: 'category',
                                label: 'סעיף',
                                options: ['סיוע ורווחה', 'הכנסת כלה', 'שכ"ל', 'כולל', 'אחר']
                            },
                            { key: 'transaction_date', label: 'תאריך פעולה' },
                            { key: 'phone', label: 'פלאפון' },
                            { key: 'email', label: 'אימייל' },
                            { key: 'type_case', label: 'דירוג מקרה' }
                        ]}
                    />

                    <button className="add-btn" onClick={handleAddBeneficiaryClick}>
                    <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#EF5DA8"
                            strokeWidth="2"
                        >
                            <circle cx="12" cy="12" r="10" />
                            <line x1="12" y1="8" x2="12" y2="16" />
                            <line x1="8" y1="12" x2="16" y2="12" />
                        </svg>
                        הוספת שם
                    </button>
                    <button
                        className="add-btn"
                        onClick={handleExportClick}
                        style={{ position: 'relative', overflow: 'visible', paddingInlineEnd: '2.2rem' }}
                    >
                        ייצוא לאקסל
                        <span
                            style={{
                                position: 'absolute',
                                right: '0.35rem',
                                bottom: '0.2rem',
                                minWidth: '1rem',
                                height: '1rem',
                                padding: '0 0.2rem',
                                borderRadius: '999px',
                                background: '#EF5DA8',
                                color: '#fff',
                                fontSize: '0.7rem',
                                lineHeight: '1rem',
                                textAlign: 'center',
                                fontWeight: 700
                            }}
                        >
                            {selectedBeneficiaryIds.length}
                        </span>
                    </button>
                    {/* <button className="add-btn" onClick={handleAddProviderClick} >
                        הוספת ספק
                    </button> */}

                </div>
                {searchKeyType === 'category' && searchTerm === 'סיוע ורווחה' && (
                    <div className="welfare-form-filter" role="group" aria-label="סינון לפי טופס">
                        <label className="welfare-form-toggle">
                            <input
                                type="checkbox"
                                checked={Boolean(welfareFormFilter)}
                                onChange={(event) => setWelfareFormFilter(event.target.checked ? 'choose' : '')}
                            />
                            <span>סינון לפי טופס</span>
                        </label>
                        {welfareFormFilter && (
                            <div className="welfare-form-options">
                                <label>
                                    <input
                                        type="radio"
                                        name="welfare-form-status"
                                        value="has_form"
                                        checked={welfareFormFilter === 'has_form'}
                                        onChange={() => setWelfareFormFilter('has_form')}
                                    />
                                    בעלי טופס
                                </label>
                                <label>
                                    <input
                                        type="radio"
                                        name="welfare-form-status"
                                        value="no_form"
                                        checked={welfareFormFilter === 'no_form'}
                                        onChange={() => setWelfareFormFilter('no_form')}
                                    />
                                    ללא טופס
                                </label>
                            </div>
                        )}
                    </div>
                )}
                <GenericList
                    data={items}
                    columns={columns}
                    onLoadMore={loadMore}
                    hasMore={hasMore}
                    loading={loading}
                    onRowClick={handleRowClick}
                    enableSelection={true}
                    selectedIds={selectedBeneficiaryIds}
                    onSelectionChange={setSelectedBeneficiaryIds}
                    rowIdKey="id"
                />
            </div>
            {/* <Footer /> */}
        </>
    );
};

export default Beneficiaries;

